<template>
  <div>
    <hr />
    <li :class="classList"></li>
  </div>
</template>

<script>
export default {
  name: "SidebarNavDivider",
  props: {
    classes: {
      type: String,
      default: ""
    }
  },
  computed: {
    classList() {
      return ["divider", ...this.itemClasses];
    },
    itemClasses() {
      return this.classes ? this.classes.split(" ") : "";
    }
  }
};
</script>

<style>
hr {
  margin-top: 0 !important;
  border: 0 !important;
  border-top: 1px solid rgba(0, 0, 0, 0.1) !important;
  height: 0;
  overflow: visible;
  display: block;
  margin-block-start: 0.5em;
  margin-block-end: 0.5em;
  margin-inline-start: auto;
  margin-inline-end: auto;
  width: 100% !important;
  background-color: transparent !important;
}
</style>
